import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DsButton } from '@frontend/ui/button';
import {
    CommonMessages,
    DeviceService,
    DynamicHtmlDirective,
    LoadingIndicatorComponent,
    MediaQueryService,
    MessageLifetime,
    MessageQueueService,
    MessageType,
    NavigationService,
    Page,
    TrackingService,
    UtilsService,
    WindowRef,
} from '@frontend/vanilla/core';
import { MessagePanelComponent } from '@frontend/vanilla/features/message-panel';
import { NavigationLayoutPageComponent } from '@frontend/vanilla/features/navigation-layout';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { DarkModeService } from '@frontend/vanilla/shared/dark-mode';
import { RouteDataService } from '@frontend/vanilla/shared/routing';
import { cloneDeep } from 'lodash-es';

import { NewAccountMenuService } from '../services/account-menu-v2.service';
import { PortalTrackingService } from '../tracking/tracking-resource.service';
import { TrackingEvent } from '../tracking/tracking.model';
import { CommunicationResourceService } from './communication-resource.service';

@Component({
    selector: 'pt-communication',
    templateUrl: 'communication.component.html',
    styleUrls: ['../../styles/portal/components/communication.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        NavigationLayoutPageComponent,
        NgTemplateOutlet,
        NgClass,
        MessagePanelComponent,
        DynamicHtmlDirective,
        FormsModule,
        LoadingIndicatorComponent,
        TrustAsHtmlPipe,
        DsButton,
    ],
})
export class CommunicationComponent implements OnInit, OnDestroy {
    initData: any;
    originalCommSettings: any;
    action: string;
    wait: boolean = false;
    groups: any[];
    showValidationAlert: boolean = false;
    noEmailAlert: boolean = false;
    noPromoAlert: boolean = false;
    AlertContent: any;
    isNotificationChecked = false;
    isContainsRTToasterNotification = false;
    selectAll: boolean = false;
    isMobileView: boolean = false;
    darkModeEnabled: boolean = false;
    isPromotionSwitchV2: boolean = false;
    allOptionsText: any;
    isEmailOpted: boolean;
    isPhoneOpted: boolean;
    dividerText: any;
    showLoader: boolean = false;
    showInfoMessage: boolean = false;
    disableSave: boolean = false;
    source: string | null;
    selectedItem: any = null;
    suppressDefaultBackBehaviour: boolean;
    suppressDefaultCloseBehaviour: boolean;
    constructor(
        private routeData: RouteDataService,
        public commonMessages: CommonMessages,
        private messageQueue: MessageQueueService,
        private communicationResource: CommunicationResourceService,
        private darkModeService: DarkModeService,
        private tracking: TrackingService,
        private mediaQueryService: MediaQueryService,
        public newAccountMenuService: NewAccountMenuService,
        private portalTrackingService: PortalTrackingService,
        private utils: UtilsService,
        public device: DeviceService,
        public navigationService: NavigationService,
        public windowRef: WindowRef,
        private page: Page,
    ) {}

    ngOnInit(): void {
        this.newAccountMenuService.addCardLayoutStyle();
        this.isMobileView = this.mediaQueryService.isActive('lt-sm');
        this.darkModeEnabled = this.darkModeService.isEnabled ? true : false;
        this.initData = this.routeData.getInitData();
        if (this.initData.enableCommunicationProducts) {
            this.originalCommSettings = cloneDeep(this.initData.communicationSettings);
            this.SelectProductsAllCount();
        }
        if (this.initData.promotionSwitchV2) {
            this.isPromotionSwitchV2 = true;
            this.getHiddenPromoValues(this.initData.communicationSettings.communicationTypes);
            this.sortCommunicationSettings();
        }
        if (!this.initData.promotionSwitchV2 && this.initData.enableCommunicationProducts) this.sortCommunicationSettings();
        this.isContainsRTToasterNotification =
            this.initData.communicationSettings &&
            !!this.initData.communicationSettings?.communicationTypes?.find((item: any) => item.name == 'RTToasterNotification');
        if (!this.isPromotionSwitchV2) {
            this.tracking.triggerEvent('Event.Functionality.GDPR', { 'page.referringAction': 'GDPR_Communication_PreferencesScreen_loaded' });
        }
        this.SelectAllCount();
        this.getSelectAllText(this.selectAll);
        if (this.initData.enableCommunicationProducts || !this.isPromotionSwitchV2) this.disableSave = true;
        this.validateAlert();

        const searchParams = this.navigationService.location.search;
        this.source = searchParams.get('source');
        if (this.source == 'fanzone') {
            this.suppressDefaultBackBehaviour = true;
            this.suppressDefaultCloseBehaviour = true;
        }
    }
    ngOnDestroy() {
        this.newAccountMenuService.removeCardLayoutStyle();
    }

    checkonback() {
        if (this.source == 'fanzone') {
            this.navigationService.goTo(this.navigationService.location.search.get('redirectionUrl') || this.page.homePage);
        }
    }
    checkonclose() {
        if (this.source == 'fanzone') {
            this.navigationService.goTo(this.navigationService.location.search.get('redirectionUrl') || this.page.homePage);
        }
    }
    getHiddenPromoValues(data: any) {
        data = data.filter((item: any) => this.initData.enabledKeys.indexOf(item.name) == -1);
        this.isPhoneOpted = data.find((x: any) => x.name == 'Phone').selected;
        this.isEmailOpted = data.find((x: any) => x.name == 'RegularMail').selected;
        this.dividerText = this.utils.format(
            this.initData.suggestionText.text,
            this.isPhoneOpted && this.isEmailOpted
                ? this.initData.dialogConfirmation.messages[data[0].name.toLowerCase()] +
                      this.initData.dialogConfirmation.messages.and +
                      this.initData.dialogConfirmation.messages[data[1].name.toLowerCase()]
                : this.isPhoneOpted
                  ? this.initData.dialogConfirmation.messages[data[0].name.toLowerCase()]
                  : this.initData.dialogConfirmation.messages[data[1].name.toLowerCase()],
        );
    }

    SelectAllCount() {
        let count = 0;
        let selectedCount = 0;
        this.initData.communicationSettings.communicationTypes
            .filter((setting: any) => setting.name != 'RTToasterNotification')
            .map((setting: any) => {
                count++;
                if (setting.selected) {
                    selectedCount++;
                }
            });
        this.selectAll = count == selectedCount ? true : false;
    }
    SelectAllOptions() {
        this.showLoader = true;
        this.initData.communicationSettings.communicationTypes.map((setting: any) => {
            setting.selected = this.selectAll;
        });
        this.showValidationAlert = this.selectAll ? false : true;
        if (!this.selectAll) this.AlertContent = this.initData.content.messages['AtleastOneAlert'];
        if (this.isPromotionSwitchV2) {
            this.getSelectAllText(this.selectAll);
            if (!this.initData.enableCommunicationProducts) {
                if (this.selectAll) this.trackNewGdprEvents('all', 'selectall');
                else this.trackNewGdprEvents('all', 'deselectall');
                this.saveAllGDPRValues();
            } else {
                this.disableSave = false;
                this.trackNewEvents(
                    'click',
                    this.selectAll ? 'on' : 'off',
                    'communication mode',
                    this.selectAll ? 'Select All' : 'Deselect All',
                    'Event.Tracking',
                );
            }
        } else {
            this.disableSave = false;
        }
    }
    getSelectAllText(value: boolean) {
        this.allOptionsText = value ? this.initData.content.messages.DeSelectAllOptions : this.initData.content.messages.SelectAllOptionsNew;
    }
    validate(item: string, value: boolean) {
        if (value) {
            this.tracking.triggerEvent('Event.Functionality.GDPR', { 'page.referringAction': 'GDPR_Communication_' + item + '_Checkbox_selected' });
        } else {
            this.tracking.triggerEvent('Event.Functionality.GDPR', { 'page.referringAction': 'GDPR_Communication_' + item + '_Checkbox_deselected' });
        }
        let isAllChecked = true;
        const allowedCommunicationTypes = Object.keys(this.initData.communicationTypesMap).filter((key) => this.initData.communicationTypesMap[key]);
        for (let i = 0; i < this.initData.communicationSettings?.communicationTypes?.length; i++) {
            if (
                allowedCommunicationTypes &&
                allowedCommunicationTypes
                    .map((name) => name.toLowerCase())
                    .indexOf(this.initData.communicationSettings.communicationTypes[i].name.toLowerCase()) > -1 &&
                !this.initData.communicationSettings.communicationTypes[i].selected &&
                this.initData.communicationSettings.communicationTypes[i].name != 'RTToasterNotification'
            ) {
                isAllChecked = false;
                break;
            }
        }
        this.selectAll = isAllChecked;
        this.disableSave = false;
        this.validateAlert();
    }
    validateAlert() {
        let isRestOfEmailChecked = false;
        let isEmailChecked = false;
        this.isNotificationChecked = false;
        this.initData.communicationSettings.communicationTypes.map((setting: any) => {
            if (setting.name == 'Email') isEmailChecked = setting.selected;
            if (setting.name == 'RTToasterNotification') this.isNotificationChecked = setting.selected;
            if (setting.name != 'Email' && setting.name != 'RTToasterNotification') {
                if (setting.selected) isRestOfEmailChecked = true;
            }
        });
        if (this.noPromoAlert) {
            this.tracking.triggerEvent('Event.Functionality.GDPR', { 'page.referringAction': 'GDPR_Communication_Info_noPromos_disappears' });
            this.noPromoAlert = false;
        }
        if (isRestOfEmailChecked && !isEmailChecked) {
            //Email missing alert
            this.AlertContent = this.initData.content.messages['EmailAlert'];
            this.showValidationAlert = true;
            this.noEmailAlert = true;
            this.tracking.triggerEvent('Event.Functionality.GDPR', { 'page.referringAction': 'GDPR_Communication_Info_noEmailPromos_shown' });
            return;
        }
        if (this.noEmailAlert) {
            this.tracking.triggerEvent('Event.Functionality.GDPR', { 'page.referringAction': 'GDPR_Communication_Info_noEmailPromos_disappears' });
            this.noEmailAlert = false;
        }
        if (!isRestOfEmailChecked && !isEmailChecked) {
            //All missing alert
            this.AlertContent = this.initData.content.messages['AtleastOneAlert'];
            this.showValidationAlert = true;
            this.noPromoAlert = true;
            this.tracking.triggerEvent('Event.Functionality.GDPR', { 'page.referringAction': 'GDPR_Communication_Info_noPromos_shown' });
            return;
        }
        if (this.noPromoAlert) {
            this.tracking.triggerEvent('Event.Functionality.GDPR', { 'page.referringAction': 'GDPR_Communication_Info_noPromos_disappears' });
            this.noPromoAlert = false;
        }
        this.showValidationAlert = false;
    }

    saveManually(name: any, isChecked: any) {
        this.showLoader = true;
        const selectedItem = this.initData.communicationSettings.communicationTypes.find((x: any) => x.name == name);
        selectedItem.selected = isChecked;
        this.SelectAllCount();
        this.getSelectAllText(this.selectAll);
        if (!this.initData.enableCommunicationProducts) {
            this.trackNewGdprEvents(
                'individual',
                selectedItem.name.toLowerCase() == 'regularmail' ? 'post' : selectedItem.name.toLowerCase(),
                isChecked,
            );
            this.saveAllGDPRValues(name, isChecked);
        } else {
            this.disableSave = false;
            this.trackNewEvents('click', isChecked ? 'on' : 'off', 'communication mode', selectedItem.name.toLowerCase(), 'Event.Tracking');
        }
    }
    saveAllGDPRValues(name?: any, isChecked?: boolean) {
        this.messageQueue.clear();
        this.communicationResource.post(this.initData.communicationSettings).subscribe(
            () => {
                this.showLoader = false;
                this.getHiddenPromoValues(this.initData.communicationSettings.communicationTypes);
                this.sortCommunicationSettings();
            },
            () => {
                this.showLoader = false;
                this.messageQueue.add(this.initData.content.messages['UpdateFail'], MessageType.Error, MessageLifetime.Single);
                this.initData.communicationSettings.communicationTypes.find((x: any) => x.name == name).selected = !isChecked;
                this.SelectAllCount();
                this.getHiddenPromoValues(this.initData.communicationSettings.communicationTypes);
            },
        );
    }

    save() {
        if (!this.isPromotionSwitchV2) {
            this.tracking.triggerEvent('Event.Functionality.GDPR', { 'page.referringAction': 'GDPR_Communication_CTA_Button_clicked' });
            if (this.isNotificationChecked) {
                this.tracking.triggerEvent('Event.Functionality.GDPR', {
                    'page.referringAction': 'GDPR_Communication_NotificationCheckbox_selected',
                });
            }
        }
        if (this.initData.enableCommunicationProducts) this.TrackProductsAndChannels(true);
        this.wait = true;
        this.messageQueue.clear({ clearPersistent: false });
        this.communicationResource.post(this.initData.communicationSettings).subscribe(
            () => {
                this.messageQueue.add(this.initData.content.messages['UpdateSuccess'], MessageType.Success, MessageLifetime.Single);
                this.tracking.triggerEvent('Event.Functionality.GDPR', { 'page.referringAction': 'GDPR_Communication_ConfirmationMessage' });
                if (this.initData.enableCommunicationProducts) {
                    this.TrackProductsAndChannels(false);
                    this.sortCommunicationSettings();
                }
                if (this.initData.promotionSwitchV2) {
                    this.isPromotionSwitchV2 = true;
                    this.getHiddenPromoValues(this.initData.communicationSettings.communicationTypes);
                    this.sortCommunicationSettings();
                }
                this.showValidationAlert = false;
                this.wait = false;
                this.scrollToTop();
                if (this.source == 'fanzone') {
                    this.navigationService.goTo(this.navigationService.location.search.get('redirectionUrl') || this.page.homePage);
                }
                if (this.source == 'crc') {
                    const msg: any = {
                        optinstatus: this.initData.communicationSettings.communicationTypes[0].selected ? '0' : '1',
                        identifier: 'Email OptIn Status',
                        source: 'Portal',
                    };
                    this.windowRef.nativeWindow.parent.postMessage(msg, '*');
                }
            },
            () => {
                this.messageQueue.add(this.initData.content.messages['UpdateFail'], MessageType.Error, MessageLifetime.Single);
                this.showValidationAlert = false;
                this.wait = false;
                this.scrollToTop();
                if (this.source == 'crc') {
                    const msg: any = {
                        optinstatus: this.initData.communicationSettings.communicationTypes[0].selected ? '0' : '1',
                        identifier: 'Email OptIn Status',
                        source: 'Portal',
                    };
                    this.windowRef.nativeWindow.parent.postMessage(msg, '*');
                }
            },
        );
    }

    private scrollToTop() {
        this.newAccountMenuService.scrollToTop();
    }

    private sortCommunicationSettings() {
        //this.groups = this.initData.communicationSettings.communicationTypes.slice(2,4);
        this.groups = this.initData.communicationSettings.communicationTypes.filter((x: any) => x.name == 'Phone' || x.name == 'RegularMail');
        this.groups.sort((first: any, second: any) => {
            return first.selected === second.selected ? first.name.localeCompare(second.name) : first.selected ? 1 : -1;
        });
        const sorter = (a: any, b: any) => {
            return this.initData.enabledKeys.indexOf(b.name) - this.initData.enabledKeys.indexOf(a.name);
        };
        if (this.initData.enableCommunicationProducts)
            this.initData.communicationSettings.communicationProducts.sort((a: any, b: any) => a.name.localeCompare(b.name));
        this.initData.communicationSettings.communicationTypes.sort(sorter);
        this.initData.communicationSettings.communicationTypes.splice(2, 1, this.groups[0]);
        this.initData.communicationSettings.communicationTypes.splice(3, 1, this.groups[1]);
    }
    private trackNewGdprEvents(locationEvent: any, eventDetails: any, isChecked?: boolean) {
        const checkedText = isChecked ? ' - on' : ' - off';
        const commonTrackingEvents: TrackingEvent = {
            CategoryEvent: 'gdpr',
            LabelEvent: 'gdpr communication preferences',
            ActionEvent: 'click',
            PositionEvent: 'my account',
            LocationEvent: locationEvent == 'all' ? 'Email | SMS | Phone | Post' : 'option selected',
            EventDetails:
                eventDetails == 'selectall' ? 'select all - on' : eventDetails == 'deselectall' ? 'deselect all - off' : eventDetails + checkedText,
        };
        this.portalTrackingService.trackEvents({ ...commonTrackingEvents });
    }
    private trackNewEvents(actionEvent: any, positionEvent: any, locationEvent: any, eventDetails: any, eventName: string) {
        const commonTrackingEvents: TrackingEvent = {
            CategoryEvent: 'account settings',
            LabelEvent: 'communication preferences',
            ActionEvent: actionEvent,
            PositionEvent: positionEvent,
            LocationEvent: locationEvent,
            EventDetails: eventDetails,
        };
        this.portalTrackingService.trackEvents({ ...commonTrackingEvents }, '', eventName);
    }
    saveProductsManually(name: any, isChecked: any) {
        this.showLoader = true;
        const selectedItem = this.initData.communicationSettings.communicationProducts.find((x: any) => x.name == name);
        selectedItem.selected = isChecked;
        this.trackNewEvents('click', isChecked ? 'on' : 'off', 'product selection', selectedItem.name.toLowerCase(), 'Event.Tracking');
        this.SelectProductsAllCount();
    }
    SelectProductsAllCount() {
        this.showInfoMessage = true;
        this.disableSave = false;
        for (let i = 0; i < this.initData.communicationSettings?.communicationProducts?.length; i++) {
            if (this.initData.communicationSettings.communicationProducts[i].selected) {
                this.showInfoMessage = false;
            }
        }
        if (this.showInfoMessage) {
            this.trackNewEvents(
                'load',
                this.initData.communication.messages?.ProductsShowInfoMessage,
                'no products selected',
                'info message',
                'contentView',
            );
        }
    }
    TrackProductsAndChannels(isSaveCTAClicked: boolean) {
        this.initData.communicationSettings.communicationTypes.map((setting: any) => {
            if (setting.selected != this.originalCommSettings.communicationTypes.find((x: any) => x.name == setting.name).selected) {
                this.trackNewEvents(
                    isSaveCTAClicked ? 'click' : 'success',
                    setting.selected ? 'on' : 'off',
                    setting.name.toLowerCase(),
                    isSaveCTAClicked ? 'save cta' : 'update',
                    'Event.Tracking',
                );
            }
        });
        this.initData.communicationSettings.communicationProducts.map((product: any) => {
            if (product.selected != this.originalCommSettings.communicationProducts.find((x: any) => x.name == product.name).selected) {
                this.trackNewEvents(
                    isSaveCTAClicked ? 'click' : 'success',
                    product.selected ? 'on' : 'off',
                    product.name.toLowerCase(),
                    isSaveCTAClicked ? 'save cta' : 'update',
                    'Event.Tracking',
                );
            }
        });
    }
    getUpdatedCoomunicationTypes() {
        if (this.initData?.communicationTypesMap) {
            const filtered = Object.keys(this.initData.communicationTypesMap).filter((key) => this.initData.communicationTypesMap[key]);
            return this.initData.communicationSettings.communicationTypes.filter((x: any) =>
                filtered?.find((k) => k.toLowerCase() == x.name?.toLowerCase()),
            );
        } else return this.initData.communicationSettings.communicationTypes;
    }
}
